import { render } from "./creditNoteCRUD.vue?vue&type=template&id=115247fe&scoped=true"
import script from "./creditNoteCRUD.vue?vue&type=script&lang=js"
export * from "./creditNoteCRUD.vue?vue&type=script&lang=js"

import "./creditNoteCRUD.vue?vue&type=style&index=0&id=115247fe&scoped=true&lang=scss"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115247fe"]])

export default __exports__